import type { WorkSpace } from '../../'

import './style.scss'

type Key = keyof Omit<WorkSpace.Stats, 'withdrawn_limit'>

const KEYS: {
	key: Key
	label: string
	max?: Key
}[] = [
	{
		key: 'invitations_sent',
		label: 'Sent invitations',
		max: 'invitations_limit'
	},
	{
		key: 'invitations_accepted_count',
		label: 'Accepted invitations'
	},
	{
		key: 'withdrawn_count',
		label: 'Withdrawn invitations'
	},
	{
		key: 'messages_count',
		label: 'Sent messages',
		max: 'messages_limit'
	},
	{
		key: 'replied_count',
		label: 'Replied'
	},
	{
		key: 'react_on_post_count',
		label: 'Likes',
		max: 'react_on_post_limit'
	},
	{
		key: 'follow_count',
		label: 'Followed',
		max: 'follow_limit'
	}
]

function getWidth(value: number, max: number) {
	if (value === 0 && max === 0) {
		return 0
	}

	// legacy logic
	if (max <= value) {
		return 100
	}

	max ||= value + 1
	return (value / max) * 100
}

export const Performed = ({
	limit = false,
	statistics
}: {
	limit?: boolean
	statistics?: WorkSpace.Stats
}) => (
	<ul className='performed'>
		{KEYS.map(({ key, label, max }) => {
			const value = statistics?.[key] || 0

			let itemMaxV: '~' | number = '~'

			if (max && limit && statistics) {
				itemMaxV = statistics[max]
			}

			const maxValue = itemMaxV === '~' ? 50 : Number(itemMaxV)

			return (
				<li className='performed-item' key={key}>
					<div className='performed-data'>
						<div>{label}</div>

						<div className='flex-container'>
							<div>
								<span>{value}</span>/{itemMaxV || 0}
							</div>
						</div>
					</div>
					<div className='performed-progress'>
						<div
							className='performed-bar'
							style={{
								width: `${getWidth(value, maxValue)}%`
							}}
						>
							&nbsp;
						</div>
					</div>
				</li>
			)
		})}
	</ul>
)
